<div class="main-container">
  <div class="circle-blue" @growScale></div>
  <div class="circle-sombra d-none d-md-flex" @growScale></div>
  <div class="circle-arch d-none d-md-flex" @growScale></div>
  <div class="logo d-none d-md-block m-4" routerLink="/iniciar-sesion">
    <img src="assets/img/logo.png" alt="logo bayport" />
  </div>
  <div class="version m-4  d-none d-md-block">
    <hr>
    <p>Bayport Colombia S.A., 2023,<br>Todos los derechos reservados<br>V.{{version}}</p>
  </div>
  <div class="contenido-autenticacion py-5">
    <div class="d-flex justify-content-center d-md-none mb-3">
      <img src="assets/img/logo-2.svg" alt="logo bayport" routerLink="/iniciar-sesion"/>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>